import { render, staticRenderFns } from "./BookingReportBudgetUtilizationNewView.vue?vue&type=template&id=b8ac3f2c&scoped=true&"
import script from "./BookingReportBudgetUtilizationNewView.vue?vue&type=script&lang=js&"
export * from "./BookingReportBudgetUtilizationNewView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ac3f2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8ac3f2c')) {
      api.createRecord('b8ac3f2c', component.options)
    } else {
      api.reload('b8ac3f2c', component.options)
    }
    module.hot.accept("./BookingReportBudgetUtilizationNewView.vue?vue&type=template&id=b8ac3f2c&scoped=true&", function () {
      api.rerender('b8ac3f2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/booking/report/BookingReportBudgetUtilizationNewView.vue"
export default component.exports